import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';

export function PatientRouteErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
        <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
        <p className="text-lg text-gray-600 mb-6">Page not found</p>
        <Link to="/patient" className="btn-primary">
          Go to Dashboard
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h1>
      <p className="text-gray-600 mb-6">
        {error instanceof Error ? error.message : 'An unexpected error occurred'}
      </p>
      <Link to="/patient" className="btn-primary">
        Go to Dashboard
      </Link>
    </div>
  );
}
